import { render, staticRenderFns } from "./VMarketplacePagination.vue?vue&type=template&id=1cfb7945"
import script from "./VMarketplacePagination.vue?vue&type=script&lang=js"
export * from "./VMarketplacePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports